export const IndustryTrackingConstant = {
  /* Action names */
  ACTION_CONTACT_EDMUNDS: 'contact_edmunds',
  ACTION_SIGN_IN: 'sign_in',

  /* Subaction names */
  CONTACT_US: 'contact_us',
  LOGIN: 'login',
};
